<template>
    <div class="setting-advanced-black-list">
        <transition name="fade-transform" mode="out-in">
          <router-view/>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'setting-advanced-black-list',
        data() {
            return {
				
			}
        },
        created() {
            
        },
        mounted() {

        },
        methods: {}
    }
</script>

<style lang="scss">

</style>
